import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionLabel } from './ui/SectionLabel';
import { COMPARATIVA } from '../data/content';
export function Comparison() {
  return <section className="w-full bg-ink px-5 py-16 sm:px-8 sm:py-24" data-id="element-35" data-mp="1l7ntmzge1wrl">
      <div className="mx-auto max-w-4xl" data-id="element-36" data-mp="1l5b3hz0h8g3g">
        <div className="text-center" data-id="element-37" data-mp="1pydz0cotdzma">
          <SectionLabel data-id="element-38" data-mp="1pzfaujdnmq52">El costo de no actuar</SectionLabel>
          <h2 className="mt-4 font-display text-3xl font-extrabold text-white sm:text-5xl" data-id="element-39" data-mp="1uy0bul0qdduk">
            ⚖️ Sin vs. Con MegaPack
          </h2>
        </div>

        <div className="mt-12 overflow-hidden rounded-3xl border border-ink-line" data-id="element-40" data-mp="1zyeipzqlihr0">
          <div className="grid grid-cols-2 border-b border-ink-line bg-ink-soft" data-id="element-41" data-mp="23yophem7pc6x">
            <p className="px-4 py-4 font-display text-[10px] font-bold uppercase tracking-[0.22em] text-red-400/90 sm:px-6 sm:text-xs" data-id="element-42" data-mp="28voudm7bs8wg">
              Sin MegaPack
            </p>
            <p className="border-l border-ink-line px-4 py-4 font-display text-[10px] font-bold uppercase tracking-[0.22em] text-violeta-300 sm:px-6 sm:text-xs" data-id="element-43" data-mp="ei5vo91k6k9k">
              Con MegaPack
            </p>
          </div>
          <ul data-id="element-44" data-mp="1h97d3sihvowo">
            {COMPARATIVA.map(row => <li key={row.con} className="grid grid-cols-2 border-b border-ink-line last:border-b-0" data-id="element-45" data-mp="1d85i5nvm1z0i">
                <p className="flex gap-2 bg-ink-card px-4 py-5 text-sm leading-snug text-violeta-100/60 sm:px-6" data-id="element-46" data-mp="189ub1kwpa2lz">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400/80" aria-hidden="true" data-id="element-47" data-mp="24zutz3ae1ovd" />
                  {row.sin}
                </p>
                <p className="flex gap-2 border-l border-ink-line bg-ink-soft px-4 py-5 text-sm font-medium leading-snug text-violeta-50 sm:px-6" data-id="element-48" data-mp="20vvhqww55c7t">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-violeta-400" aria-hidden="true" data-id="element-49" data-mp="1r0ley6xx50sz" />
                  {row.con}
                </p>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}